import { useLocation, Link } from 'react-router-dom';

export default function FooterSection() {
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-accent-light text-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* 会社情報 */}
          <div className="lg:col-span-2">
            <div className="space-y-4 text-gray-600">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <img 
                    src="https://static.readdy.ai/image/b90f078cf90066d31dc5715f1c64017a/36c76535dddd88638941c6c99da87bd5.png" 
                    alt="Y's STUDIO ロゴ" 
                    className="w-10 h-10 object-contain"
                  />
                  <h4 className="font-semibold text-navy">株式会社 Y's STUDIO</h4>
                </div>
                <div className="space-y-2">
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-cta mt-1 flex-shrink-0"></i>
                    <span>〒657-0041 神戸市灘区琵琶町2-3-6</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-user-line text-cta mt-1 flex-shrink-0"></i>
                    <span>代表：山本 久和</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-phone-line text-cta flex-shrink-0"></i>
                    <a href="tel:090-2199-3209" className="hover:text-cta transition-colors cursor-pointer">
                      090-2199-3209
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-mail-line text-cta flex-shrink-0"></i>
                    <a href="mailto:ysstudio.kobe@gmail.com" className="hover:text-cta transition-colors cursor-pointer">
                      ysstudio.kobe@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ナビゲーション */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-navy">ナビゲーション</h4>
            <ul className="space-y-3 text-gray-600">
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-cta transition-colors cursor-pointer">
                  戦略設計
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="hover:text-cta transition-colors cursor-pointer">
                  制作事例
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('thoughts')} className="hover:text-cta transition-colors cursor-pointer">
                  戦略設計責任者について
                </button>
              </li>
              <li>
                <a href="/director-profile" className="hover:text-cta transition-colors cursor-pointer">
                  技術責任者について
                </a>
              </li>
            </ul>
          </div>

          {/* サポート */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-navy">サポート</h4>
            <ul className="space-y-3 text-gray-600">
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-cta transition-colors cursor-pointer">
                  お問い合わせ
                </button>
              </li>
              <li>
                <a href="/privacy-policy" className="hover:text-cta transition-colors cursor-pointer">
                  プライバシーポリシー
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* ソーシャルメディア */}
        <div className="border-t border-accent mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 hover:text-cta transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-cta transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-cta transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-500 hover:text-cta transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
            
            <div className="text-center text-gray-500 text-sm">
              <p>&copy; 2025 株式会社 Y's STUDIO All rights reserved. | 
                <a href="https://readdy.ai/?origin=logo" className="hover:text-cta transition-colors ml-2 cursor-pointer">
                  Powered by Readdy
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}